import { useParams, useNavigate } from "react-router-dom";
import { useState } from "react";
import RepositorioDocumento from "../Repositorio/RepositorioDocumento";

const RepositorioDocumental = () => {
  const { proyecto, mode } = useParams();
  const navigate = useNavigate();
  const [openDrawer, setOpenDrawer] = useState(true);
  if (!proyecto) return null;
  const resolvedMode = mode ?? "full";
  const onCloseDrawable = () => {
    setOpenDrawer(false);
    navigate(-1);
  };

  return (
    <RepositorioDocumento
      open={openDrawer}
      onCloseMetodo={onCloseDrawable}
      proyectoCodigo={proyecto}
      mode={resolvedMode}
    />
  );
};


export default RepositorioDocumental;
